// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__T6r0Z","toggle":"styles_toggle__UcCrq","preview":"styles_preview__3mRHY"};